import { omit, unionWith } from "lodash-es"
import React from "react"
import { useDispatch } from "react-redux"
import CustomSpinner from "components/Atoms/CustomSpinner"
import MapCenterButton from "components/Templates/MapCenterButton"
import {
  useDispatchOrdersList,
  useTripOrders,
} from "graphql/dispatch/dispatch.hooks"
import { EDIT_TRIP_ORDERS } from "store/dispatch.redux"
import OrderMarkers from "./OrderMarkers"
const OrdersMapView = () => {
  const { data: orders, loading } = useDispatchOrdersList()
  const dispatch = useDispatch()
  useTripOrders(({ tripDetails }) => {
    const grouped = tripDetails?.bookings?.reduce((prev, booking) => {
      const orderId = booking.order.id
      const prevItems = prev.get(orderId)?.orderItems
      const allItems = booking?.order?.orderItems?.map(o => ({
        ...o,
        orderId: booking?.order?.id,
        isSelected: false,
      }))

      const orderItem = {
        ...booking.orderItem,
        isSelected: true,
        newQuantity:
          booking?.requiredQuantity ??
          booking?.orderItem.quantity - booking?.orderItem?.bookedQuantity,
        requiredQuantity: booking?.requiredQuantity,
        orderId: booking?.order?.id,
        scheduleId: booking?.schedule.id,
        bookingId: booking?.id,
      }
      const newItems = prevItems ? prevItems?.concat(orderItem) : [orderItem]

      return prev.set(orderId, {
        ...booking.order,
        allItems: allItems,
        orderItems: newItems,
      })
    }, new Map())

    grouped.forEach((value, key) => {
      grouped.set(key, {
        ...value,
        xyz: "abc",
        orderItems: unionWith(
          value?.orderItems,
          value?.allItems,
          (n: any, p: any) => n.id === p.id
        ),
      })
    })

    dispatch({
      type: EDIT_TRIP_ORDERS,
      payload: {
        ...omit(tripDetails, ["bookings", "DEPOrganisationUser"]),
        organisationUser: tripDetails.DEPOrganisationUser,
        estimatedStartTime: new Date(tripDetails.estimatedStartTime),
        // Reduce the bookings array to a Map DS, so we can store it nicely as a key => value pair
        selectedOrders: grouped,
      },
    })
  })

  if (loading) return <CustomSpinner />
  return (
    <OrderMarkers orders={orders}>
      <MapCenterButton
        items={orders}
        getItemLocation={o => {
          const ship = o?.shippingAddress
          return {
            lat: ship?.latitude,
            lng: ship?.longitude,
          }
        }}
      />
    </OrderMarkers>
  )
}

export default OrdersMapView
